import { Tag } from '@ironhack/design-system2/components/tag';
import { type ReactElement } from 'react';

type Props = {
  badge: {
    colorScheme: 'purple' | 'yellow';
    text: string;
  };
};

export const NavItemBadge = (props: Props): ReactElement => {
  const {
    badge: { colorScheme, text },
  } = props;

  return (
    <Tag
      borderRadius="20px"
      colorScheme={colorScheme === 'purple' ? 'interactive' : colorScheme}
      size="s"
      text={text}
      textProps={{ textStyle: 's' }}
    />
  );
};
